// SPEED FIX 2026-07-29 - reescrito
//
// La version anterior de este archivo, pese a llamarse "safe performance", era una de las
// principales fuentes de trabajo en el hilo principal:
//
//  a) Tenia un MutationObserver sobre document.body con {childList:true, subtree:true} que
//     re-ejecutaba preventImageShifts() y optimizeResponsiveImages() en CADA cambio del DOM.
//     Cada pasada hacia querySelectorAll de todas las <img> y llamaba a getBoundingClientRect()
//     una por una => layout sincrono forzado (layout thrashing) con 53 imagenes en la pagina.
//
//  b) optimizeResponsiveImages() generaba srcsets con el formato ANTIGUO de URL de Shopify
//     (_400x.jpg). Las imagenes de esta tienda usan URLs con ?v=..., asi que producia URLs
//     invalidas. Codigo roto que ademas gastaba CPU.
//
//  c) Ponia img.width = img.naturalWidth en imagenes responsive, pisando el dimensionado del CSS.
//
// Ahora: una sola pasada, lecturas separadas de escrituras (sin thrashing), sin observer,
// y sin tocar srcset. Lo unico que se conserva es marcar loading/fetchpriority en las imagenes
// que no lo traen del tema.
(function () {
  'use strict';

  function tagImages() {
    var imgs = document.querySelectorAll('img:not([data-dims-set])');
    if (!imgs.length) return;

    var vh = window.innerHeight;
    var reads = [];

    // FASE 1: solo lecturas. Se agrupan para que el navegador haga un unico layout.
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('loading')) { img.dataset.dimsSet = '1'; continue; }
      reads.push({ el: img, top: img.getBoundingClientRect().top });
    }

    // FASE 2: solo escrituras.
    for (var j = 0; j < reads.length; j++) {
      var el = reads[j].el;
      var top = reads[j].top;
      el.dataset.dimsSet = '1';
      if (top < vh) {
        el.setAttribute('loading', 'eager');
        if (top < vh / 2) el.setAttribute('fetchpriority', 'high');
      } else {
        el.setAttribute('loading', 'lazy');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagImages, { once: true });
  } else {
    tagImages();
  }

  // Para contenido inyectado despues (drawer del carrito, etc.) se re-ejecuta una sola vez
  // cuando el navegador esta libre, en lugar de en cada mutacion del DOM.
  window.addEventListener('load', function () {
    if ('requestIdleCallback' in window) requestIdleCallback(tagImages);
    else setTimeout(tagImages, 500);
  }, { once: true });

  window.SafePerformance = { tagImages: tagImages };
})();
